import { createUseStyles } from 'react-jss';

const styles = {
  importSelectDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  importButton: { marginLeft: '0.5rem' },
  importTable: { marginTop: '1rem' },
  orText: { marginLeft: '0.5em', marginRight: '0.5em' }
};

export const useStyles = createUseStyles(styles, {
  name: 'ImportDialog'
});
